import { render, staticRenderFns } from "./printTable.vue?vue&type=template&id=fdf9b734&"
import script from "./printTable.vue?vue&type=script&lang=js&"
export * from "./printTable.vue?vue&type=script&lang=js&"
import style0 from "./printTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/muhu/pts/aics/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
installComponents(component, {VDivider})
